import { Fragment } from 'react';
import queryString from 'query-string';

import { ImageViewer } from 'features/image/components/ImageViewer';
import { PDFViewer } from 'features/pdf/components/PDFViewer';
import { TextViewer } from 'features/text/components/TextViewer';
import { ImageTiffViewer } from 'features/image-tiff/components/ImageTiffViewer';

export function DocumentViewer() {
    const queryParams = queryString.parse(window.location.search);

    const pdfViewerExtensions = ['pdf', 'tif', 'tiff'];
    const otimizedTiffExtensions = ['tif_cog', 'tiff_cog'];
    const txtViewerExtensions = ['txt'];

    let fileType: string | null = null;
    let tenantToken: string | null = null;

    if (typeof queryParams.fileType === 'string') {
        fileType = queryParams.fileType;
    } else if (Array.isArray(queryParams.fileType)) {
        fileType = queryParams.fileType[0];
    }

    if (typeof queryParams.tenantToken === 'string') {
        tenantToken = queryParams.tenantToken;
    } else if (Array.isArray(queryParams.tenantToken)) {
        tenantToken = queryParams.tenantToken[0];
    }

    if (fileType === null && tenantToken === '238506eb-3664-4fe2-8a58-3996e5534163') {
        fileType = 'pdf';
    }

    return (
        <Fragment>
            {fileType && pdfViewerExtensions.includes(fileType.toLowerCase()) ?
                (<PDFViewer />) :
                (fileType && otimizedTiffExtensions.includes(fileType.toLowerCase()) ?
                    (<ImageTiffViewer />) :
                    (fileType && txtViewerExtensions.includes(fileType.toLowerCase()) ?
                        (<TextViewer />) :
                        (<ImageViewer />)
                    )
                )
            }
        </Fragment>
    );
}